<script>
import ParseFunctions from '@/components/ParseFunctions'
import Constants from '@/components/Constants'
export default {
  name: 'IntegrationAuthorize',
  components: {},
  mixins: [ParseFunctions, Constants],
  data() {
    return {}
  },
  async created() {
    let teamId = this.$route.query.teamId
    let calledFrom = this.$route.query.calledFrom || 'IntegrationAuthorize'
    let system = this.$route.query.system

    let res = await this.getIntegrationInstallUrl(teamId, calledFrom, system)
    if (res.status === 'ok') {
      let state = res.state
      window.open(res.url, '_self')
    } else {
      this.showServerError(res)
    }
  },
  methods: {},
}
</script>
